import type { ChatMessage, Persistence } from "borogove";
import { useOutletContext } from "react-router";
import { useEffect, useRef, useState } from "react";

const debugEnabled = (() => {
	try {
		return localStorage.getItem("CHEOGRAM_DEBUG") === "1";
	} catch {
		return false;
	}
})();

let nextName = 1;

function exposeMessage(message: ChatMessage) {
	let name;
	do {
		name = `m${nextName++}`;
	} while (name in window);
	Object.defineProperty(window, name, {
		value: message,
		configurable: true,
		writable: true,
	});
	console.log(`${name} (window.${name})`, message);
}

export const MessageDebugger = ({ m }: { m: ChatMessage }) =>
	debugEnabled ? <MessageDebuggerButton m={m} /> : null;

const MessageDebuggerButton = ({ m }: { m: ChatMessage }) => {
	const { persistence } = useOutletContext<{ persistence: Persistence }>();
	const serverId = m.serverId;
	const [feedback, setFeedback] = useState("");
	const feedbackTimer = useRef<ReturnType<typeof setTimeout>>();
	useEffect(() => () => clearTimeout(feedbackTimer.current), []);
	if (!serverId) return <div className="message-debugger">NO SERVER ID</div>;

	return (
		<div className="message-debugger">
			<button
				type="button"
				title="Copy server ID"
				aria-label={`Copy server ID ${serverId}`}
				onClick={async (event) => {
					event.stopPropagation();
					try {
						await navigator.clipboard.writeText(serverId);
						setFeedback("Copied");
					} catch {
						setFeedback("Copy failed");
					}
					clearTimeout(feedbackTimer.current);
					feedbackTimer.current = setTimeout(() => setFeedback(""), 1000);
					try {
						const message = await persistence.getMessage(
							m.account(),
							m.chatId(),
							serverId,
							null,
						);
						if (!message)
							throw new Error(`No stored message for server ID ${serverId}`);
						exposeMessage(message);
					} catch (error) {
						console.error("Message debugger lookup failed", serverId, error);
					}
				}}
			>
				{serverId}
			</button>
			<span role="status">{feedback && ` · ${feedback}`}</span>
		</div>
	);
};
